import { render, staticRenderFns } from "./CriticalHourDistributionChart.vue?vue&type=template&id=dfd8672e&scoped=true&"
import script from "./CriticalHourDistributionChart.vue?vue&type=script&lang=js&"
export * from "./CriticalHourDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./CriticalHourDistributionChart.vue?vue&type=style&index=0&id=dfd8672e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8672e",
  null
  
)

export default component.exports